// tutorActions.js
import {
    FETCH_TUTORS_REQUEST,
    FETCH_TUTORS_SUCCESS,
    FETCH_TUTORS_FAILURE,
    ADD_TUTOR_REQUEST,
    ADD_TUTOR_SUCCESS,
    ADD_TUTOR_FAILURE,
    UPDATE_TUTOR_REQUEST,
    UPDATE_TUTOR_SUCCESS,
    UPDATE_TUTOR_FAILURE,
    DELETE_TUTOR_REQUEST,
    DELETE_TUTOR_SUCCESS,
    DELETE_TUTOR_FAILURE,
  } from "./actionTypes";
  
  // Fetch tutors action creators
  export const fetchTutorsRequest = (data) => ({
    type: FETCH_TUTORS_REQUEST,
    payload: data,
  });
  
  export const fetchTutorsSuccess = (tutors) => ({
    type: FETCH_TUTORS_SUCCESS,
    payload: tutors,
  });
  
  export const fetchTutorsFailure = (error) => ({
    type: FETCH_TUTORS_FAILURE,
    payload: error,
  });
  
  // Add tutor action creators
  export const addTutorRequest = (tutor, onClose) => ({
    type: ADD_TUTOR_REQUEST,
    payload: { tutor, onClose },
  });
  
  export const addTutorSuccess = (tutor) => ({
    type: ADD_TUTOR_SUCCESS,
    payload: tutor,
  });
  
  export const addTutorFailure = (error) => ({
    type: ADD_TUTOR_FAILURE,
    payload: error,
  });
  
  // Update tutor action creators
  export const updateTutorRequest = (id, tutor, onClose) => ({
    type: UPDATE_TUTOR_REQUEST,
    payload: { id, tutor, onClose },
  });
  
  export const updateTutorSuccess = (tutor) => ({
    type: UPDATE_TUTOR_SUCCESS,
    payload: tutor,
  });
  
  export const updateTutorFailure = (error) => ({
    type: UPDATE_TUTOR_FAILURE,
    payload: error,
  });
  
  // Delete tutor action creators
  export const deleteTutorRequest = (tutorId) => ({
    type: DELETE_TUTOR_REQUEST,
    payload: tutorId,
  });
  
  export const deleteTutorSuccess = (tutorId) => ({
    type: DELETE_TUTOR_SUCCESS,
    payload: tutorId,
  });
  
  export const deleteTutorFailure = (error) => ({
    type: DELETE_TUTOR_FAILURE,
    payload: error,
  });
  